module.exports = __webpack_public_path__ + "static/media/logo.8ddf28f7.png";